/**
 * Conversations + messages API endpoints
 */

import { fetchApi } from '../core';
import type {
  ConversationResponse,
  CreateConversationData,
  MessageResponse,
  SendMessageData,
  UpdateMessageData,
} from '../types';

export function list(componentName: string = 'Unknown') {
  return fetchApi<ConversationResponse[]>('/conversations', {}, componentName);
}

export function create(data: CreateConversationData, componentName: string = 'Unknown') {
  return fetchApi<ConversationResponse>(
    '/conversations',
    { method: 'POST', body: JSON.stringify(data) },
    componentName
  );
}

export function getById(conversationId: string, componentName: string = 'Unknown') {
  return fetchApi<ConversationResponse>(`/conversations/${conversationId}`, {}, componentName);
}

export function archive(conversationId: string, componentName: string = 'Unknown') {
  return fetchApi<ConversationResponse>(
    `/conversations/${conversationId}/archive`,
    { method: 'POST' },
    componentName
  );
}

export function listMessages(conversationId: string, componentName: string = 'Unknown') {
  return fetchApi<MessageResponse[]>(
    `/conversations/${conversationId}/messages`,
    {},
    componentName
  );
}

export function sendMessage(
  conversationId: string,
  data: SendMessageData,
  componentName: string = 'Unknown'
) {
  return fetchApi<MessageResponse>(
    `/conversations/${conversationId}/messages`,
    { method: 'POST', body: JSON.stringify(data) },
    componentName
  );
}

export function updateMessage(
  messageId: string,
  data: UpdateMessageData,
  componentName: string = 'Unknown'
) {
  return fetchApi<MessageResponse>(
    `/messages/${messageId}`,
    { method: 'PUT', body: JSON.stringify(data) },
    componentName
  );
}

export function deleteMessage(messageId: string, componentName: string = 'Unknown') {
  return fetchApi<{ message: string }>(
    `/messages/${messageId}`,
    { method: 'DELETE' },
    componentName
  );
}

export function markRead(conversationId: string, componentName: string = 'Unknown') {
  return fetchApi<{ read_at: number }>(
    `/conversations/${conversationId}/read`,
    { method: 'POST' },
    componentName
  );
}
